import { useLogout } from 'App/api/auth';
import { useModules } from 'store/hooks/useModules';
import NavigationBar from './NavigationBar';

const EMPTY_MODULES = [];

const NavigationBarContainer = props => {
  const modules = useModules() || EMPTY_MODULES;
  const logout = useLogout();

  return <NavigationBar {...props} modules={modules} logout={logout} />;
};

export default NavigationBarContainer;
